/** Are printed cards on for this teacher (STORY-089)? On the cloud, when the `cards` flag is;
 * on a local host always, because nobody can set that host's flags and Tier 0 is for exactly
 * the room without internet. The print link, the scan action (M3) and the card half of the
 * course's device section (M4) all ask this. */
import { useFlags } from "../platform/flags";
import { isLocalHost } from "../platform/localHost";

/** The rule, apart from the hooks: the `cards` flag, or a local host. */
export const cardsEnabledFrom = (flags: Readonly<Record<string, boolean | undefined>>, localHost: boolean): boolean =>
  flags.cards === true || localHost;

export function useCardsEnabled(): boolean {
  return cardsEnabledFrom(useFlags(), isLocalHost());
}
